export default __webpack_public_path__ + "./image/a97ebae92f2a405ff10343f7fc253bf7.png";